// @ts-strict-ignore
import { ExchangeOrgBody, exchangeOrgToken } from "@getbread/api-client-auth-v2";
import { AxiosRequestConfig } from "axios";

import { getConfig } from "merchant-portal-frontend/src/config";
import { browserLogs } from "merchant-portal-frontend/src/logger";
import { BreadToken, decodeBreadToken } from "merchant-portal-frontend/src/model/common/auth";

export async function exchangeAccessToken(
	accessToken: string,
	merchantID?: string,
): Promise<BreadToken> {
	// setup options for axios override:
	const options: AxiosRequestConfig = {
		baseURL: getConfig("apiurl"),
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	};

	try {
		const response = await exchangeOrgToken(
			{
				appID: getConfig("oktaclientid"),
				merchantID,
			} as ExchangeOrgBody,
			options,
		);

		return decodeBreadToken(response.data.token);
	} catch (error) {
		browserLogs.logger.error({
			message: `auth.exchangeAccessToken: ${error?.message}`,
			context: error,
		});
		throw error;
	}
}
